import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import Gatewise from "./tabs/Gatewise";
import SIwise from "./tabs/SIwise";
import Overall from "./tabs/Overall";
import { useReportsStore } from "../ReportsStore";
import { useSearchParams } from "react-router-dom";

const SiReport = () => {
  const { tab, setTab } = useReportsStore();
  const [searchParams, setSearchParams] = useSearchParams();
  const [firstRender, setFirstRender] = useState(true);
  useEffect(() => {
    if (firstRender) {
      setSearchParams({ tab: 1 });
      setFirstRender(false);
    } else {
      setSearchParams({ tab: tab });
    }
  }, [tab]);

  const onChange = (key) => {
    setTab(key);
  };
  const items = [
    {
      key: "1",
      label: `Overall Report`,
      children: <Overall />,
    },
    {
      key: "2",
      label: `Gateway-wise Report`,
      children: <Gatewise />,
    },
    {
      key: "3",
      label: `SI-wise Report`,
      children: <SIwise />,
    },
  ];

  return (
    <>
      <Tabs items={items} size="small" onChange={onChange} />
    </>
  );
};

export default SiReport;
